export default "__VITE_ASSET__BI06gETN__"